module.exports = __webpack_public_path__ + "static/media/25542378_1703518536389997_8185959074263101190_o.3d5b6a03.jpg";